module.exports = __webpack_public_path__ + "static/media/fkcci-award-pic.20467a25.jpg";